<div class="relative">
  <button
    aria-hidden="false"
    (click)="close()"
    class="absolute top-0 right-0 p-2 text-gray-500 hover:text-gray-700 inline-flex"
  >
    <mat-icon>close</mat-icon>
  </button>
  <mat-dialog-content class="!p-4">
    <ng-container *ngTemplateOutlet="data.content"></ng-container>
  </mat-dialog-content>
</div>
